
import { defineComponent, computed, PropType, getCurrentInstance } from 'vue';
import { ArticleInfo, ArticleActionType } from '../../models/main';
import { roundingNum } from '@/common/utils';
import { sendLog } from '~/common/radar';

export default defineComponent({
  props: {
    articleInfo: {
      type: Object as PropType<ArticleInfo>,
      default: () => ({}),
    },
  },
  setup(props, ctx) {
    const { proxy } = getCurrentInstance() as { proxy: Record<string, any> }

    const likeCount = computed(() => {
      const count = props.articleInfo?.like_count
      return count ? roundingNum(count) : proxy.$root.$t('k_335878')
    })

    const commentCount = computed(() => {
      const count = props.articleInfo?.comment_count
      return count ? roundingNum(count) : proxy.$root.$t('k_396689')
    })

    const handleItemClick = (item: ArticleActionType) => {
      sendLog({
        type: 'click',
        name: 'ARTICLE_BUTTON',
        value: {
          source: 'mobile',
          button_type: item,
        },
      })

      ctx.emit('handleItemClick', item)
    }

    return {
      likeCount,
      commentCount,
      handleItemClick,
      ArticleActionType,
    }
  },
})
